import AccountDetailsCard from 'Agent/Accounts/components/AccountDetailCards';
import 'Agent/Accounts/components/AccountDetails.sass';
import {getAccountDetails, getAccountImages} from 'Agent/Accounts/ducks/accountDetail';
import {updatefeatureVariables} from 'Core/ducks/featureToggle';
import {useBreadcrumbs} from 'Core/hooks/useBreadcrumbs';
import {toEither} from 'Core/models/Async';
import {sequenceS} from 'fp-ts/lib/Apply';
import {either, fold} from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import qs from 'query-string';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {RouteComponentProps, useLocation} from 'react-router-dom';
import {ReducerState} from 'rootReducer';
import {renderAsync} from 'Shared/components/RenderAsync';
import {AgencyFilters} from 'Shared/models/AgencyFilters';
import { DataSource } from 'Shared/utilities/DataSourceUtility';
import { AccountSourceType } from '../AccountRouteConstants';

type AccountDetailsProps = {
  selectedAgency: AgencyFilters;
} & RouteComponentProps<{accountId: string; accountNumber: string}>;

const AccountDetails = (props: AccountDetailsProps) => {
  const dispatch = useDispatch();
  const {match} = props;
  const {accountDetails} = useSelector((state: ReducerState) => state.accountDetails);
  const {userClaims} = useSelector((state: ReducerState) => state.user.profile);
  const {featureVariables} = useSelector((state: ReducerState) => state.featureToggle);
  const {search} = useLocation();
  const parsedQueryParams = qs.parse(search);

  const {accountId, accountNumber} = match.params;
  useBreadcrumbs(accountNumber, props.match.url);

  const {selectedAgency} = props;

  useEffect(() => {
    const accountIdForImages = Number(parsedQueryParams.source) === DataSource.EIS ? parsedQueryParams.groupNbr as string : accountId;
    dispatch(
      getAccountDetails(
        selectedAgency.encryptedIdentifier,
        accountId,
        accountNumber,
        parsedQueryParams.source as string,
        selectedAgency.agentNumbers,
        parsedQueryParams.groupNbr as string,
        parsedQueryParams.productCd as string
      )
    );
    dispatch(getAccountImages(selectedAgency.encryptedIdentifier, accountIdForImages, parsedQueryParams.source as string, parsedQueryParams.accountSource as AccountSourceType));
  }, [dispatch, accountId, selectedAgency.encryptedIdentifier, accountNumber]);

  useEffect(() => {
    const updateFeature = {...featureVariables, FOOTER_OPEN_DEFAULT: false};
    dispatch(updatefeatureVariables(updateFeature));
  }, []);
  
  return pipe(
    sequenceS(either)({
      accountDetail: toEither(accountDetails),
      userClaimsData: toEither(userClaims),
    }),
    fold(renderAsync, ({accountDetail, userClaimsData}) => (
      <AccountDetailsCard accountDetail={accountDetail} userClaims={userClaimsData} />
    ))
  );
};

export default AccountDetails;
